import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4ef0a45b&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=4ef0a45b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0a45b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef0a45b')) {
      api.createRecord('4ef0a45b', component.options)
    } else {
      api.reload('4ef0a45b', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=4ef0a45b&scoped=true&", function () {
      api.rerender('4ef0a45b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Logo.vue"
export default component.exports